import React from 'react';
import { ProviderTransactionsTable } from './ProviderTransactionTable';

export const ProviderTransactionsList: React.FC = () => {
  return <ProviderTransactionsTable />;
};
